import type { NavbarButtonIcon } from './navbar-button'

type NavigationItem = {
  name: string
  path: string
  label: string
  icon?: NavbarButtonIcon
}

type NavigationGroup = Omit<NavigationItem, 'path'> & {
  children: NavigationItem[]
}

export const NAVIGATION_ITEMS: (NavigationItem | NavigationGroup)[] = [
  {
    name: 'home',
    path: '/',
    label: 'page.home.title',
    icon: 'home',
  },
  {
    name: 'orders',
    path: '/orders',
    label: 'page.orders.title',
    icon: 'orders',
  },
  {
    name: 'general-settings',
    path: '/settings/general',
    label: 'page.shop_settings.title',
    icon: 'settings',
  },
  {
    name: 'shipping-settings',
    path: '/settings/shipping',
    label: 'page.settings.shipping.shipping_returns',
    icon: 'objects',
  },
]
